import Countdown from './Countdown';
import type { Snapshot } from './types';

/**
 * The optional break overlay, shown while a break is active. The clock is paused;
 * this counts down the break budget. The candidate may resume early. Telemetry keeps
 * running, and closing the tab still forfeits the test.
 */
export default function BreakScreen({
  snapshot,
  clockOffsetMs,
  onResume,
  busy,
}: {
  snapshot: Snapshot;
  clockOffsetMs: number;
  onResume: () => void;
  busy: boolean;
}) {
  const brk = snapshot.break;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-accent/5 p-6 text-center">
      <p className="text-xs uppercase tracking-widest text-accent">Break — the clock is paused</p>
      <h1 className="mt-3 text-3xl font-semibold">Take a moment</h1>

      <div className="mt-10">
        <Countdown deadlineAt={brk?.deadlineAt ?? null} clockOffsetMs={clockOffsetMs} size="large" />
      </div>

      <p className="mt-8 max-w-md text-sm leading-relaxed text-ink/70">
        Your test timer is frozen. When you resume — or when this countdown reaches zero — the test
        continues exactly where you left off, with the same time remaining.
      </p>

      <button type="button" className="btn-primary mt-8 px-10 py-3 text-base" onClick={onResume} disabled={busy}>
        {busy ? 'Resuming…' : 'Resume the test'}
      </button>

      <p className="mt-6 max-w-md rounded-md border border-danger/40 bg-danger/5 px-4 py-3 text-sm font-medium text-danger">
        Leave this tab open. Closing it still ends your test.
      </p>
    </div>
  );
}
